const QUESTIONS = [
  {
    id: 'q1',
    text: 'Hoe omschrijf je jouw dagelijkse leefgewoonten?',
    type: 'single',
    options: [
      { id: 'a', text: 'Gezonde voeding, voldoende beweging en een goede nachtrust', score: 0 },
      { id: 'b', text: 'Grotendeels gezond, met af en toe een uitzondering', score: 1 },
      { id: 'c', text: 'Onregelmatig. Veel drukte en te weinig rust', score: 2 },
      { id: 'd', text: 'Al een tijdje uit balans', score: 3 }
    ]
  },
  {
    id: 'q2',
    text: 'Heb je momenteel een periode waarin je meer drinkt, eet of laat opblijft?',
    type: 'single',
    options: [
      { id: 'a', text: 'Nee, ik hou mijn normale routine aan', score: 0 },
      { id: 'b', text: 'Ja, tijdelijk door feestjes, vakanties of een drukke periode', score: 2 },
      { id: 'c', text: 'Ja, dat duurt al een paar maanden', score: 3 }
    ]
  },
  {
    id: 'q3',
    text: 'Hoe ervaar je jouw stressniveau op dit moment?',
    type: 'single',
    options: [
      { id: 'a', text: 'Laag. Ik ontspan gemakkelijk', score: 0 },
      { id: 'b', text: 'Af en toe gestrest, maar ik herstel snel', score: 1 },
      { id: 'c', text: 'Regelmatig gespannen. Volledig ontspannen lukt moeilijk', score: 2 },
      { id: 'd', text: 'Constant gestrest en overbelast', score: 3 }
    ]
  },
  {
    id: 'q4',
    text: 'Welke van de volgende klachten herken je bij jezelf?',
    type: 'multi',
    optional: true,
    note: 'Meerdere antwoorden mogelijk — laat leeg als er niets van toepassing is.',
    options: [
      { id: 'a', text: 'Moeheid of hersenmist', score: 1, label: 'moeheid of hersenmist', serious: false },
      { id: 'b', text: 'Slecht of onrustig slapen', score: 1, label: 'slaapproblemen', serious: false },
      { id: 'c', text: 'PMS of hormonale wisselingen', score: 1, label: 'hormonale wisselingen', serious: false },
      { id: 'd', text: 'Huidproblemen of snel blauwe plekken krijgen', score: 1, label: 'huidproblemen', serious: false },
      { id: 'e', text: 'Moeite met afvallen', score: 1, label: 'moeite met afvallen', serious: false },
      { id: 'f', text: 'Een opgeblazen gevoel of constant trek in eten', score: 1, label: 'een opgeblazen gevoel', serious: false },
      { id: 'g', text: 'Menopauze-gerelateerde klachten', score: 1, label: 'menopauze-gerelateerde klachten', serious: false },
      { id: 'h', text: 'Hoofdpijn of spierspanning', score: 1, label: 'hoofdpijn of spierspanning', serious: false },
      { id: 'i', text: 'Verhoogde leverwaarden (bloedonderzoek)', score: 3, label: 'verhoogde leverwaarden', serious: true },
      { id: 'j', text: 'Verhoogde triglyceriden (bloedonderzoek)', score: 3, label: 'verhoogde triglyceriden', serious: true },
      { id: 'k', text: 'Verhoogde nuchtere bloedsuiker (bloedonderzoek)', score: 3, label: 'verhoogde bloedsuikerwaarden', serious: true },
      { id: 'l', text: 'Insulineresistentie of (pre)diabetes', score: 3, label: 'insulineresistentie of (pre)diabetes', serious: true },
      { id: 'm', text: 'Chronische vermoeidheid', score: 3, label: 'chronische vermoeidheid', serious: true },
      { id: 'n', text: 'PCOS', score: 3, label: 'PCOS', serious: true },
      { id: 'o', text: 'Vocht vasthouden in benen of buik', score: 3, label: 'vochtophoping', serious: true },
      { id: 'p', text: 'Vruchtbaarheidsproblemen of onregelmatige cyclus', score: 3, label: 'vruchtbaarheidsproblemen', serious: true }
    ]
  },
  {
    id: 'q5',
    text: 'Wat gebruik je minstens één keer per week?',
    type: 'multi',
    optional: true,
    note: 'Meerdere antwoorden mogelijk — laat leeg als er niets van toepassing is.',
    options: [
      { id: 'a', text: 'Koffie (espresso, latte, cappuccino of oploskoffie)', score: 0.5 },
      { id: 'b', text: 'Frisdrank of energiedranken', score: 1 },
      { id: 'c', text: 'Vruchtensap of smoothies', score: 0.5 },
      { id: 'd', text: 'Kant-en-klare of bewerkte maaltijden', score: 1 },
      { id: 'e', text: 'Snoep, chocolade of andere zoetigheden', score: 1 },
      { id: 'f', text: 'Gedroogd fruit (rozijnen, dadels, abrikozen)', score: 0.5 },
      { id: 'g', text: 'Honing of siropen (ahornsiroop, agave)', score: 0.5 },
      { id: 'h', text: 'Light producten of kunstmatige zoetstoffen', score: 0.5 },
      { id: 'i', text: 'Gebak of koekjes', score: 1 },
      { id: 'j', text: 'Ontbijtgranen of mueslirepen', score: 0.5 },
      { id: 'k', text: 'IJs of andere diepvriesdesserts', score: 0.5 },
      { id: 'l', text: 'Fastfood of afhaalmaaltijden', score: 1 }
    ]
  },
  {
    id: 'q6',
    text: 'Hoe zou je de luchtkwaliteit in jouw woonomgeving omschrijven?',
    type: 'single',
    options: [
      { id: 'a', text: 'Hoge blootstelling — ik woon in een stad met veel verkeer of industrie', score: 2 },
      { id: 'b', text: 'Matige blootstelling — ik woon in een buitenwijk of aan de stadsrand', score: 1 },
      { id: 'c', text: 'Weinig blootstelling — ik woon in een klein stadje of dorp', score: 0.5 },
      { id: 'd', text: 'Nauwelijks blootstelling — ik woon op het platteland', score: 0 }
    ]
  },
  {
    id: 'q7',
    text: 'Gebruik je medicatie, en zo ja, wat voor soort?',
    type: 'single',
    options: [
      { id: 'a', text: 'Geen medicatie', score: 0 },
      { id: 'b', text: 'Af en toe pijnstillers (maximaal 3 keer per maand)', score: 1 },
      { id: 'c', text: 'Antibiotica (nu of in de afgelopen 3 maanden)', score: 2 },
      { id: 'd', text: 'Wekelijks pijnstillers of andere medicatie (hormonen, cholesterol, etc.)', score: 2 },
      { id: 'e', text: 'Dagelijks pijnstillers of andere medicatie (hormonen, cholesterol, etc.)', score: 3 }
    ]
  },
  {
    id: 'q8',
    text: 'Hoe zou je jouw energieniveau door de dag omschrijven?',
    type: 'single',
    options: [
      { id: 'a', text: 'Stabiel en goed de hele dag', score: 0 },
      { id: 'b', text: 'Wisselend', score: 1 },
      { id: 'c', text: 'Regelmatig laag', score: 2 },
      { id: 'd', text: 'Voortdurend uitgeput', score: 3 }
    ]
  },
  {
    id: 'q9',
    text: 'Hoeveel keer per week beweeg of sport je?',
    type: 'single',
    options: [
      { id: 'a', text: 'Zelden of nooit', score: 3 },
      { id: 'b', text: '1 tot 2 keer per week', score: 2 },
      { id: 'c', text: '3 tot 4 keer per week', score: 0.5 },
      { id: 'd', text: '5 keer per week of meer', score: 0 }
    ]
  },
  {
    id: 'q10',
    text: 'Hoe vaak drink je alcohol?',
    type: 'single',
    options: [
      { id: 'a', text: 'Zelden of nooit', score: 0 },
      { id: 'b', text: 'Af en toe (1 tot 2 keer per week)', score: 1 },
      { id: 'c', text: 'Regelmatig (3 tot 6 keer per week)', score: 2 },
      { id: 'd', text: 'Bijna dagelijks (7 keer per week of meer)', score: 3 }
    ]
  }
];

const RESULTS = {
  1: {
    badge: 'GEEN ACUUT RISICO',
    dots: 1,
    title: 'Je lever werkt goed. Maar preventie loont.',
    explanation: 'Toch werkt je lever elke dag hard. Zelfs bij een gezonde levensstijl krijgt je lever te maken met omgevingstoxines, stresshormonen en bewerkte ingrediënten. Zonder dat je het merkt, stapelt de belasting langzaam op.',
    adviceTitle: 'Detox Boost (dagelijks)',
    adviceText: 'Neem dagelijks Detox Boost om de natuurlijke ontgifting van je lever te ondersteunen. Zo houd je je lever in topconditie, ook op de lange termijn.'
  },
  2: {
    badge: 'TIJDELIJK VERHOOGD RISICO',
    dots: 2,
    title: 'Je lever heeft het nu even druk. Ondersteuning helpt.',
    explanation: 'Je lever verwerkt alles op de achtergrond, dag en nacht. Je ervaart nog geen grote klachten, maar de belasting is duidelijk hoger dan normaal. Hoe langer dit aanhoudt zonder gerichte ondersteuning, hoe meer herstelwerk je lever te doen krijgt.',
    adviceTitle: 'Liverboost Forte (min. 1 maand) + Detox Boost (dagelijks)',
    adviceText: 'Start met een gerichte kuur van minimaal 1 maand Liverboost Forte. Dit geeft je lever de extra ondersteuning die het nu nodig heeft. Combineer dit met dagelijkse Detox Boost voor structureel onderhoud van de ontgifting.'
  },
  3: {
    badge: 'VERHOOGDE LEVERBELASTING',
    dots: 3,
    title: 'Je lichaam stuurt signalen. Luister ernaar.',
    explanation: 'Je lever beheert meer dan 500 functies in je lichaam — van hormoonregulatie tot spijsvertering en energieproductie. Als die processen verstoord raken, voel je dat op plekken waar je het niet direct met de lever verbindt.',
    adviceTitle: 'Liverboost Forte (min. 3 maanden) + Detox Boost (dagelijks)',
    adviceText: 'Neem Liverboost Forte minimaal 3 maanden als gerichte kuur. Geef je lever de tijd om te herstellen. Combineer dit met dagelijkse Detox Boost voor continue ondersteuning. Een langere periode geeft betere resultaten.'
  },
  4: {
    badge: 'HOGE LEVERBELASTING',
    dots: 4,
    title: 'Dit zijn serieuze signalen. Wacht niet langer.',
    explanation: 'Dit zijn tekenen dat je lever al een tijdje overbelast is. Hoe langer dit aanhoudt zonder gerichte aanpak, hoe meer schade kan ophopen. Het lichaam is geduldig, maar niet oneindig.',
    adviceTitle: 'Liverboost Forte (min. 6 maanden) + Detox Boost (dagelijks)',
    adviceText: 'Start zo snel mogelijk met Liverboost Forte. Reken op minimaal 6 maanden voor een diepgaand herstel. Combineer dit altijd met dagelijkse Detox Boost. Bespreek dit ook met je arts of apotheker, zeker als je reeds medicatie gebruikt.'
  }
};

let currentQ = 0;
let answers = {};

function startQuiz() {
  currentQ = 0;
  answers = {};
  show('screen-question');
  renderQuestion();
}

function show(id) {
  document.querySelectorAll('.screen').forEach(s => s.classList.remove('active'));
  document.getElementById(id).classList.add('active');
  window.scrollTo(0, 0);
}

function renderQuestion() {
  const q = QUESTIONS[currentQ];
  const pct = (currentQ / QUESTIONS.length) * 100;
  document.getElementById('progress-fill').style.width = pct + '%';
  document.getElementById('progress-label').textContent = 'Vraag ' + (currentQ + 1) + ' van ' + QUESTIONS.length;
  document.getElementById('q-text').textContent = q.text;

  const noteEl = document.getElementById('q-note');
  if (q.note) { noteEl.textContent = q.note; noteEl.style.display = 'block'; }
  else { noteEl.style.display = 'none'; }

  const wrap = document.getElementById('q-options');
  wrap.innerHTML = '';
  const savedAns = answers[q.id];

  q.options.forEach(opt => {
    const div = document.createElement('div');
    div.className = 'option';

    const isSel = q.type === 'single'
      ? savedAns === opt.id
      : Array.isArray(savedAns) && savedAns.includes(opt.id);
    if (isSel) div.classList.add('selected');

    div.innerHTML = '<div class="option-key">' + opt.id.toUpperCase() + '</div><span>' + opt.text + '</span>';
    div.addEventListener('click', () => selectOption(q, opt.id, div));
    wrap.appendChild(div);
  });

  const isLast = currentQ === QUESTIONS.length - 1;
  const nextBtn = document.getElementById('btn-next');
  nextBtn.textContent = isLast ? 'Bekijk uitslag →' : 'Volgende →';
  document.getElementById('btn-back').style.visibility = currentQ === 0 ? 'hidden' : 'visible';

  updateNextBtn();
}

function selectOption(q, optId, clicked) {
  if (q.type === 'single') {
    document.querySelectorAll('.option').forEach(o => o.classList.remove('selected'));
    clicked.classList.add('selected');
    answers[q.id] = optId;
  } else {
    if (!answers[q.id]) answers[q.id] = [];
    if (clicked.classList.contains('selected')) {
      clicked.classList.remove('selected');
      answers[q.id] = answers[q.id].filter(x => x !== optId);
    } else {
      clicked.classList.add('selected');
      answers[q.id].push(optId);
    }
  }
  updateNextBtn();
}

function updateNextBtn() {
  const q = QUESTIONS[currentQ];
  const ans = answers[q.id];
  const ok = q.optional
    ? true
    : q.type === 'single' ? !!ans : (Array.isArray(ans) && ans.length > 0);
  document.getElementById('btn-next').disabled = !ok;
}

function nextQuestion() {
  if (currentQ < QUESTIONS.length - 1) {
    currentQ++;
    renderQuestion();
  } else {
    showResult();
  }
}

function prevQuestion() {
  if (currentQ > 0) { currentQ--; renderQuestion(); }
}

function calcLevel() {
  const q4 = answers.q4 || [];
  const q4Opts = QUESTIONS[3].options;
  const seriousIds = q4Opts.filter(o => o.serious).map(o => o.id);
  const hasSeriousSymptoms = q4.some(id => seriousIds.includes(id));
  if (hasSeriousSymptoms || answers.q7 === 'e') return 4;

  const mildIds = q4Opts.filter(o => !o.serious).map(o => o.id);
  const mildCount = q4.filter(id => mildIds.includes(id)).length;
  if (mildCount >= 3) return 3;

  if (answers.q2 === 'b') return 2;

  let score = 0;
  QUESTIONS.forEach(q => {
    const ans = answers[q.id];
    if (q.type === 'single' && ans) {
      const o = q.options.find(x => x.id === ans);
      if (o) score += o.score;
    } else if (q.type === 'multi' && Array.isArray(ans)) {
      ans.forEach(id => {
        const o = q.options.find(x => x.id === id);
        if (o) score += o.score;
      });
    }
  });

  if (score >= 10) return 3;
  return 1;
}

function buildPersonalText(level) {
  const q4 = answers.q4 || [];
  const q4Opts = QUESTIONS[3].options;
  const labels = q4.map(id => q4Opts.find(o => o.id === id)?.label).filter(Boolean);
  const q7Opt = QUESTIONS[6].options.find(o => o.id === answers.q7);
  const q8Opt = QUESTIONS[7].options.find(o => o.id === answers.q8);

  if (level === 1) {
    return 'Je hebt geen opvallende klachten ingevuld en je energieniveau is overwegend goed. Dat is een sterk uitgangspunt.';
  }
  if (level === 2) {
    return 'Je hebt aangegeven dat je momenteel een tijdelijke periode hebt van meer eten, drinken of later opblijven dan normaal. Herkenbaar. Maar je lever verwerkt dit alles op de achtergrond, dag en nacht.';
  }
  if (level === 3) {
    let t = '';
    if (labels.length > 0) {
      const listed = labels.length === 1 ? labels[0] : labels.slice(0,-1).join(', ') + ' en ' + labels[labels.length-1];
      t += 'Je hebt aangegeven dat je last hebt van ' + listed + '. ';
    }
    if (answers.q8 && answers.q8 !== 'a' && q8Opt) {
      t += 'Je energieniveau is ' + q8Opt.text.toLowerCase() + '. ';
    }
    if (!t) t = 'Op basis van jouw antwoorden zijn er meerdere signalen van verhoogde leverbelasting. ';
    t += 'Dit zijn geen toevalligheden.';
    return t;
  }
  if (level === 4) {
    const parts = [];
    if (labels.length > 0) {
      const listed = labels.length === 1 ? labels[0] : labels.slice(0,-1).join(', ') + ' en ' + labels[labels.length-1];
      parts.push('klachten zoals ' + listed);
    }
    if (answers.q7 && answers.q7 !== 'a' && q7Opt) parts.push(q7Opt.text.toLowerCase());
    if (answers.q8 && answers.q8 !== 'a' && q8Opt) parts.push('een ' + q8Opt.text.toLowerCase());
    if (parts.length > 0) {
      return 'Jouw antwoorden laten een duidelijk patroon zien: ' + parts.join(', ') + '. Dit zijn serieuze signalen die om een gerichte aanpak vragen.';
    }
    return 'Jouw antwoorden laten een patroon zien van ernstige leverbelasting. Dit vraagt om diepgaande, langdurige ondersteuning.';
  }
  return '';
}

function showResult() {
  const level = calcLevel();
  const r = RESULTS[level];

  document.getElementById('result-badge').textContent = r.badge;

  const dotsEl = document.getElementById('score-dots');
  dotsEl.innerHTML = '';
  for (let i = 1; i <= 4; i++) {
    const d = document.createElement('div');
    d.className = 'score-dot' + (i <= r.dots ? ' filled' : '');
    dotsEl.appendChild(d);
  }

  document.getElementById('result-title').textContent = r.title;
  document.getElementById('result-personal').textContent = buildPersonalText(level);
  document.getElementById('result-explanation').textContent = r.explanation;
  document.getElementById('advice-title').textContent = r.adviceTitle;
  document.getElementById('advice-text').textContent = r.adviceText;

  show('screen-result');
}

function restartQuiz() {
  currentQ = 0;
  answers = {};
  show('screen-start');
}